import React, { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { api } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import { EventCard } from "@/components/EventCard";
import type { AppEvent } from "@/types";

export const PlaceEvents = ({ venueId }: { venueId: string }) => {
  const { t } = usePrefs();
  const [list, setList] = useState<AppEvent[]>([]);
  const [all, setAll] = useState(false);
  useEffect(() => { api.get("/events", { params: { venue_id: venueId } }).then((r) => setList(r.data)).catch(() => setList([])); }, [venueId]);
  if (!list.length) return null;
  return (
    <section data-testid="place-events" className="space-y-3">
      <h2 className="text-base md:text-lg font-bold inline-flex items-center gap-2"><CalendarDays className="h-5 w-5 text-primary" />{t("pe.title")} <span className="text-sm text-muted-foreground">({list.length})</span></h2>
      <div className="grid sm:grid-cols-2 gap-4">
        {(all ? list : list.slice(0, 6)).map((e, i) => <EventCard key={e.event_id} e={e} index={i} share />)}
      </div>
      {list.length > 6 && (
        <button onClick={() => setAll(!all)} data-testid="place-events-toggle" className="h-10 px-5 rounded-full border bg-card text-sm font-bold hover:bg-accent">
          {all ? t("pe.less") : t("pe.all").replace("{n}", String(list.length))}
        </button>
      )}
    </section>
  );
};
